export default {
  usps: [
    {
      id: 'usps-Letter',
      label: 'USPS - Letter'
    },
    {
      id: 'usps-Card',
      label: 'USPS - Card'
    },
    {
      id: 'usps-Flat',
      label: 'USPS - Flat'
    },
    {
      id: 'usps-Parcel',
      label: 'USPS - Parcel'
    },
    {
      id: 'usps-LargeParcel',
      label: 'USPS - LargeParcel'
    },
    {
      id: 'usps-IrregularParcel',
      label: 'USPS - IrregularParcel'
    },
    {
      id: 'usps-FlatRateEnvelope',
      label: 'USPS - FlatRateEnvelope'
    },
    {
      id: 'usps-FlatRateLegalEnvelope',
      label: 'USPS - FlatRateLegalEnvelope'
    },
    {
      id: 'usps-FlatRatePadedEnvelope',
      label: 'USPS - FlatRatePadedEnvelope'
    },
    {
      id: 'usps-FlatRateGiftCardEnvelope',
      label: 'USPS - FlatRateGiftCardEnvelope'
    },
    {
      id: 'usps-FlatRateWindowEnvelope',
      label: 'USPS - FlatRateWindowEnvelope'
    },
    {
      id: 'usps-FlatRateCarboardEnvelope',
      label: 'USPS - FlatRateCarboardEnvelope'
    },
    {
      id: 'usps-SmallFlatRateEnvelope',
      label: 'USPS - SmallFlatRateEnvelope'
    },
    {
      id: 'usps-SmallFlatRateBox',
      label: 'USPS - SmallFlatRateBox'
    },
    {
      id: 'usps-LargeFlatRateBox',
      label: 'USPS - USPS - LargeFlatRateBox'
    },
    {
      id: 'usps-RegionalRateBoxA',
      label: 'USPS - RegionalRateBoxA'
    },
    {
      id: 'usps-RegionalRateBoxB',
      label: 'USPS - RegionalRateBoxB'
    },
    {
      id: 'usps-RegionalRateBoxC',
      label: 'USPS - RegionalRateBoxC'
    },
    {
      id: 'usps-LargeFlatRateBoardGameBox',
      label: 'USPS - LargeFlatRateBoardGameBox'
    }
  ],
  fedex: [
    {
      id: 'FedExEnvelope',
      label: 'Envelope'
    },
    {
      id: 'FedExBox',
      label: 'Box'
    },
    {
      id: 'FedExPak',
      label: 'Pak'
    },
    {
      id: 'FedExTube',
      label: 'Tube'
    },
    {
      id: 'FedEx10kgBox',
      label: '10kgBox'
    },
    {
      id: 'FedEx25kgBox',
      label: '25kgBox'
    },
  ],
  ontrac: [
    {
      id: 'Letter',
      label: 'Letter'
    }
  ],
  ups: [
    {
      id: 'ups-UPSLetter',
      label: 'UPSLetter'
    },
    {
      id: 'ups-UPSExpressBox',
      label: 'UPSExpressBox'
    },
    {
      id: 'ups-UPS25kgBox',
      label: 'UPS25kgBox'
    },
    {
      id: 'ups-UPS10kgBox',
      label: 'UPS10kgBox'
    },
    {
      id: 'ups-Tube',
      label: 'Tube'
    },
    {
      id: 'ups-Pak',
      label: 'Pak'
    },
    {
      id: 'ups-Pallet',
      label: 'Pallet'
    },
    {
      id: 'ups-SmallExpressBox',
      label: 'SmallExpressBox'
    },
    {
      id: 'ups-MediumExpressBox',
      label: 'MediumExpressBox'
    },
    {
      id: 'ups-LargeExpressBox',
      label: 'LargeExpressBox'
    }
  ],
  gso: [],
  canada_post: []
}